<a data-nosnippet class="skip-content-link skip-to-main-content" [routerLink]="[]" fragment="main-content">{{
  'common.skip_to_main.link' | translate
}}</a>

<div [ngClass]="wrapperClasses$ | async" class="d-flex flex-column min-vh-100">
  <!--ICSA Customisations Start-->
  <div class="custom-header-box">
    <custom-header />
  </div>
  <!--ICSA Customisations ends-->
  <!-- <header data-testing-id="page-header" class="top"><ish-header /></header> -->

  <div class="wrapper">
    <main class="container main-container" id="main-content" tabindex="-1">
      <router-outlet />
    </main>
  </div>

  <footer data-testing-id="section-footer" class="mt-auto">
    <ish-footer />
  </footer>
</div>

<ish-cookies-banner />

<ish-lazy-copilot />
